export default "__VITE_PUBLIC_ASSET__a4d7525a__"